import { render, staticRenderFns } from "./MergeTagsList.vue?vue&type=template&id=b2cf5ce6&"
import script from "./MergeTagsList.vue?vue&type=script&lang=js&"
export * from "./MergeTagsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports